// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"258":"98ef5cc9","719":"24a80a14"}[chunkId] + ".chunk.css";
};